import { render, staticRenderFns } from "./SliderGroup.vue?vue&type=template&id=414b415a&scoped=true&"
import script from "./SliderGroup.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SliderGroup.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SliderGroup.vue?vue&type=style&index=0&id=414b415a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414b415a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('414b415a')) {
      api.createRecord('414b415a', component.options)
    } else {
      api.reload('414b415a', component.options)
    }
    module.hot.accept("./SliderGroup.vue?vue&type=template&id=414b415a&scoped=true&", function () {
      api.rerender('414b415a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SliderGroup/SliderGroup.vue"
export default component.exports